const endlessSVG = (color = '#7629F2') => `
<svg width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.90625 8.8125C2.74891 8.8125 1 7.06359 1 4.90625C1 2.74891 2.74891 1 4.90625 1" stroke="${color}" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.5312 1C17.6886 1 19.4375 2.74891 19.4375 4.90625C19.4375 7.06359 17.6886 8.8125 15.5312 8.8125" stroke="${color}" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.90625 1C8.8125 1 11.625 8.8125 15.5312 8.8125" stroke="${color}" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.5312 1C11.625 1 8.8125 8.8125 4.90625 8.8125" stroke="${color}" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`

export default endlessSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/endlessSVG.js